import styled from "styled-components";

export const SwitchOptionContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
